import { useEffect, useRef, useState } from 'react';

// Manages a 4-state save indicator and a self-clearing timer.
//
// States: 'idle' | 'saving' | 'saved' | 'error'
//
// Usage:
//   const { status, setSaving, flashSaved, flashError } = useSaveIndicator();
//   <SaveToast status={status} />
//
//   async function save() {
//     setSaving();
//     try { await api.brand.set(...); flashSaved(); }
//     catch { flashError(); }
//   }
export function useSaveIndicator({ savedMs = 2000, errorMs = 4000 } = {}) {
  const [status, setStatus] = useState('idle');
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  function setSaving() {
    clearTimeout(timerRef.current);
    setStatus('saving');
  }

  function flashSaved() {
    setStatus('saved');
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setStatus((s) => (s === 'saved' ? 'idle' : s));
    }, savedMs);
  }

  function flashError() {
    setStatus('error');
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setStatus((s) => (s === 'error' ? 'idle' : s));
    }, errorMs);
  }

  return { status, setSaving, flashSaved, flashError };
}
